import { Component, ChangeDetectorRef } from '@angular/core';
import { FormGroup, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { environment } from '@environment';

import { StorageService } from '@core/services/util/storage.service';
import { LoginService } from '@core/services/login/login.service';
import { ToastrService } from '@core/services/notification/toastr.service';
import { UtilityService } from '@core/services/util/utility.service';
import { CustomerService } from '@core/services/customer/customer.service';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { SentryBreadcrumbsService } from '@app/core/services/sentry-breadcrumbs.service';

import { LoginBaseComponent } from '@modules/authentication/components/login-base/login-base.component';
import { PonchoUIModule } from '@poncho/ui';
import { NgStyle } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.scss'],
    standalone: true,
    imports: [MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, NgStyle, PonchoUIModule]
})
export class SigninComponent extends LoginBaseComponent {
    signinForm: FormGroup;
    loginViaOtp = false;
    DEPLOY_URL: string;
    enableResendOtp = false;
    timeDelay: any;
    timerInterval: any;

    constructor(
        public storageService: StorageService,
        public loginService: LoginService,
        public toastrService: ToastrService,
        public utilityService: UtilityService,
        public customerService: CustomerService,
        public authenticationService: AuthenticationService,
        public cdr: ChangeDetectorRef,
        public breadCrumb: SentryBreadcrumbsService
    ) {
        super(
            storageService,
            loginService,
            toastrService,
            utilityService,
            customerService,
            authenticationService,
            cdr,
            breadCrumb
        );
        this.DEPLOY_URL = environment.DEPLOY_URL;

        const mobileNumber = this.storageService.get('phone_number');
        this.signinForm = new FormGroup({
            mobile: new FormControl({ value: mobileNumber, disabled: true }),
            password: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6)]))
        });
        this.initiateTimer();
    }

    loginWithOtp(option: boolean, login_method = '') {
        this.loginViaOtp = option;
        this.signinForm.controls['password'].reset();

        if (option) {
            this.initiateTimer();
            this.enableResendOtp = false;
            this.generateOtp(login_method);
        }
    }

    signIn() {
        if (!this.signinForm.valid) {
            this.utilityService.markFormFieldsAsTouched(this.signinForm);
            return;
        }

        const password = this.signinForm.value.password;
        this.btnLoading = true;

        if (this.loginViaOtp) {
            this.signInWithOtp(password);
        } else {
            this.signInWithPassword(password);
        }
    }

    initiateTimer() {
        this.timeDelay = 30;
        clearInterval(this.timerInterval);

        this.timerInterval = setInterval(() => {
            this.timeDelay = Number(this.timeDelay);
            if (this.timeDelay > 0) {
                this.timeDelay--;
                this.timeDelay = this.timeDelay < 10 ? '0' + this.timeDelay : this.timeDelay;
            } else {
                this.enableResendOtp = true;
                clearInterval(this.timerInterval);
            }
        }, 1000);
    }
}
